var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#00aa3e",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 4.711H5c-1.105 0-2 .857-2 1.913v13.394c0 1.057.895 1.913 2 1.913h14c1.105 0 2-.857 2-1.913V6.624c0-1.057-.895-1.913-2-1.913z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 10.452h18m-5-7.654v3.827M8 2.798v3.827"
  }))));
};
export default SvgCalendar;